import React from 'react';
import PropTypes from 'prop-types';

import cls from 'classnames/bind';
import s from './TravellersFooter.scss';

const cx = cls.bind(s);

class TravellersFooter extends React.PureComponent {
  static propTypes = {
    ages: PropTypes.shape({
      child: PropTypes.shape({
        age: PropTypes.number,
      }),
      infant: PropTypes.shape({
        age: PropTypes.number,
      }),
    }).isRequired,
  };

  render() {
    const { ages } = this.props;

    return (
      <dl className={cx('TravellersFooter')}>
        <div className={cx('itemContainer')}>
          <dt>
            Ребёнок {ages.infant.age}&mdash;{ages.child.age} лет
          </dt>
          <dd className={cx('defenition')}>дешевле на 40&mdash;60%</dd>
        </div>
        <div className={cx('itemContainer')}>
          <dt>Без места, до {ages.infant.age} лет</dt>
          <dd className={cx('defenition')}>бесплатно</dd>
        </div>
      </dl>
    );
  }
}

export default TravellersFooter;
